import { createFileRoute } from '@tanstack/react-router'
import TicketDetailPage from '@/spa/pages/TicketDetailPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/tickets/$id')({
  component: TicketDetailPage,
  errorComponent: routeErrorComponent,
})
